import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { Individual } from "../../../Component/Model/Dto/Individual";
import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import {useRecoilValue} from "recoil";
import {userRolesState} from "../../../State/user.Atom";
import {EE123PeopleRole_Edit} from "../../../Component/Common/Constants/UserRoles";

interface EmployeeStructureRow {
    Id:                     number;
    IdNumber:               string;
    EmployeeCode:           string;
    FullName:               string;
    Race:                   string;
    Gender:                 string;
    Disabled:               string;
    OccupationalLevel:      string;
    Position:               string;
    Youth:                  string;
    Province:               string;
    Actions:                ActionType[];
}

interface EmployeeStructureTable {
    columns: Array<TableColumn>;
    rows: Array<EmployeeStructureRow>;
}

export function EmployeeStructureTableMapper(dataObject: Individual.SummaryDtoIn[], onEdit: (id:number)=> void ): EmployeeStructureTable {
    const userRoles = useRecoilValue(userRolesState);


    const columns = [
        { Header: 'ID Number', accessor: 'IdNumber', id: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Full Name', accessor: 'FullName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Race', accessor: 'Race', id:'RaceName', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Gender', accessor: 'Gender', id:'GenderId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Disabled', accessor: 'Disabled', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Occupational Level', accessor: 'OccupationalLevel', id:'OccupationalLevelName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} /> },
        { Header: 'Position', accessor: 'Position', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Youth', accessor: 'Youth', id: "IsYouth", Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true },
        { Header: 'Province', accessor: 'Province',  id:'ProvinceName', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item: Individual.SummaryDtoIn, index: number) => ({
            Id: item.IndividualId,
            IdNumber: item.IdentificationNumber,
            EmployeeCode: item.EmployeeCode,
            FullName: item.FullName,
            Race: item.Race,
            Gender: item.Gender,
            Disabled: item.Disabled ? 'Yes' : 'No',
            OccupationalLevel: item.OccupationalLevel,
            Position: item.Position,
            Youth: item.IsYouth ? 'Yes' : 'No',
            Province: item.ProvinceName,
            Actions:  [
                userRoles.includes(EE123PeopleRole_Edit)
                    ? {
                        key: index.toString(),
                        label: 'View/Edit',
                        action: () => onEdit(item.IndividualId),
                        icon: {
                            color: 'info',
                            name: 'edit',
                        },
                    }
                    : {
                        key: index.toString(),
                        label: 'View',
                        action: () => onEdit(item.IndividualId),
                        icon: {
                            color: 'info',
                            name: 'visibility',
                        },
                    },
            ]
            
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}